var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"create-discount"},[_c('PBackButton',{staticClass:"container"}),_c('CDiscountForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }